import { clamp } from "./clamp.js";
function inertiaFinalValue(initialValue, initialDelta, dampFactor = 0.85) {
  dampFactor = clamp(dampFactor, 1e-5, 0.99999);
  let delta = initialDelta;
  let finalValue = initialValue;
  while (Math.abs(delta) > 0.1) {
    finalValue += delta;
    delta *= dampFactor;
  }
  return finalValue;
}
export {
  inertiaFinalValue
};
//# sourceMappingURL=inertiaFinalValue.js.map
